<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container" v-if="modulo != 0">
            <router-link to="/usuario">Usuarios</router-link>
            > {{ datoUsuario.nombre }}
          </div>
          <div class="breadcrumb-container" v-else>
            <router-link to="/MenuPrincipal">Inicio</router-link>
          </div>
        </div>
        <div class="col-1">
          <span class="material-symbols-outlined" style="font-size:32px;color:blue; cursor: pointer;"
            @click="showModalHelp = true">help
          </span>
        </div>
      </div>
    </div>
    <!-- Area de notificación -->
    <div class="notification-area" v-for="(notificacion, index) in notificaciones" :key="index">
      <div class="notification-message"
        :class="{ 'is-success': notificacion.type === 'success', 'is-error': notificacion.type === 'error' }">
        {{ notificacion.message }}
      </div>
    </div>
    <Modal v-model:modelValue="showModalHelp" title="Ayuda - Usuario">
      <AyudaUsuario />
    </Modal>
    <hr>
    <!-- Modal -->
    <div class="modal-dialog modal-xl" style="z-index: 1;">
      <div class="modal-content">
        <form>
          <div class="modal-body">
            <!-- Botón Lista de Valores  Perfil -->
            <div class="mb-3">
              <div class="row">
                <div class="col-5">
                  <label for="nombre" class="form-label">Nombre</label>
                  <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoUsuario.nombre"
                    disabled>
                </div>
                <div class="col-5">
                  <label for="idPerfil" class="form-label"> Perfil</label>
                  <input type="text" class="form-control" id="perfilNombre" name="perfilNombre"
                    v-model="datoUsuario.perfilNombre" disabled>
                </div>
                <div class="col-2">
                  <label for="suscriptor" class="form-label">Suscriptor</label><br>
                  <input type="checkbox" id="suscriptor" name="suscriptor" v-model="suscriptorBoolean" disabled
                         style="transform: scale(3);">
                </div>
              </div>
            </div>
            <!-- Botón Lista de Valores  Perfil -->
            <!--             <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="clave" class="form-label">Clave</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="clave" name="clave" v-model="datoUsuario.clave" style='text-transform:uppercase' required>
                </div>
              </div>
            </div> -->
            <div class="mb-3">
              <div class="row">
                <div class="col-3">
                  <input type="checkbox" id="moduloAdministracion" name="moduloAdministracion"
                    v-model="moduloAdministracionBoolean">
                  <label for="moduloAdministracion" class="form-label"
                    style="margin-left: 8px;">ModuloAdministracion</label>
                </div>
                <div class="col-3">
                  <input type="checkbox" id="moduloAtencion" name="moduloAtencion" v-model="moduloAtencionBoolean">
                  <label for="moduloAtencion" class="form-label" style="margin-left: 8px;">ModuloAtencion</label>
                </div>
                <div class="col-3">
                  <input type="checkbox" id="moduloFacturacion" name="moduloFacturacion"
                    v-model="moduloFacturacionBoolean">
                  <label for="moduloFacturacion" class="form-label" style="margin-left: 8px;">ModuloFacturacion</label>
                </div>
                <div class="col-3">
                  <input type="checkbox" id="moduloDashboards" name="moduloDashboards"
                    v-model="moduloDashboardsBoolean">
                  <label for="moduloDashboards" class="form-label" style="margin-left: 8px;">ModuloDashboards</label>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-3">
                  <input type="checkbox" id="menuParametros" name="menuParametros" v-model="menuParametrosBoolean">
                  <label for="menuParametros" class="form-label" style="margin-left: 8px;">MenuParametros</label>
                </div>
                <div class="col-3">
                  <input type="checkbox" id="menuProcesos" name="menuProcesos" v-model="menuProcesosBoolean">
                  <label for="menuProcesos" class="form-label" style="margin-left: 8px;">MenuProcesos</label>
                </div>
                <div class="col-3">
                  <input type="checkbox" id="menuReportes" name="menuReportes" v-model="menuReportesBoolean">
                  <label for="menuReportes" the="form-label" style="margin-left: 8px;">MenuReportes</label>
                </div>
                <div class="col-3">
                  <input type="checkbox" id="menuAyuda" name="menuAyuda" v-model="menuAyudaBoolean">
                  <label for="menuAyuda" class="form-label" style="margin-left: 8px;">MenuAyuda</label>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-3">
                  <input type="checkbox" id="opcionConsulta" name="opcionConsulta" v-model="opcionConsultaBoolean">
                  <label for="opcionConsulta" class="form-label" style="margin-left: 8px;">OpcionConsulta</label>
                </div>
                <div class="col-3">
                  <input type="checkbox" id="opcionOperaciones" name="opcionOperaciones"
                    v-model="opcionOperacionesBoolean">
                  <label for="opcionOperaciones" class="form-label" style="margin-left: 8px;">OpcionOperaciones</label>
                </div>
                <div class="col-3">
                  <input type="checkbox" id="opcionDescarga" name="opcionDescarga" v-model="opcionDescargaBoolean">
                  <label for="opcionDescarga" class="form-label" style="margin-left: 8px;">OpcionDescarga</label>
                </div>
                <div class="col-3">
                  <input type="checkbox" id="opcionMenu" name="opcionMenu" v-model="opcionMenuBoolean">
                  <label for="opcionMenu" class="form-label" style="margin-left: 8px;">OpcionMenu</label>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-9">
                  <button @click.prevent="mostrarOcultarBloque">{{ mostrarBloque ? '(-) Menos información' : '(+) Más información' }}</button>
                </div>
                <div class="col-3">
                  <router-link class="btn btn-light" :to="`/personaform/${p_idPersona}`">Más información
                    ...</router-link>
                  <!-- 
                  <button type="submit" class="btn btn-light" @click.prevent="guardarUsuario" v-if="btnCrear" title="Guardar">
                    <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
                  </button>
                  -->
                  <button type="submit" class="btn btn-light" @click.prevent="guardarEditUsuario" title="Actualizar">
                    <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
                  </button>
                </div>
              </div>
            </div>
            <div v-if="mostrarBloque" class="mb-3">
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idUsuario" class="form-label">IdUsuario</label>
                    <input type="text" class="form-control" id="idUsuario" name="idUsuario"
                      v-model="datoUsuario.idUsuario" disabled>
                  </div>
                  <div class="col-2">
                    <label for="idSuscripcion" class="form-label"> Suscripcion</label>
                    <input type="text" class="form-control" id="idSuscripcion" name="idSuscripcion"
                      v-model="datoUsuario.idSuscripcion" disabled>
                  </div>
                  <div class="col-2">
                    <label for="idUsuarioReg" class="form-label">IdUsuarioReg</label>
                    <input type="text" class="form-control" id="idUsuarioReg" name="idUsuarioReg"
                      v-model="datoUsuario.idUsuarioReg" disabled>
                  </div>
                  <div class="col-2">
                    <label for="fechaReg" class="form-label">FechaReg</label>
                    <input type="text" class="form-control" id="fechaReg" name="fechaReg" 
                           :value="getFormattedDate(datoUsuario.fechaReg)" disabled>
                  </div>
                  <div class="col-2">
                    <label for="idUsuarioAct" class="form-label">IdUsuarioAct</label>
                    <input type="text" class="form-control" id="idUsuarioAct" name="idUsuarioAct"
                      v-model="datoUsuario.idUsuarioAct" disabled>
                  </div>
                  <div class="col-2">
                    <label for="fechaAct" class="form-label">FechaAct</label>
                    <input type="text" class="form-control" id="fechaAct" name="fechaAct"
                           :value="getFormattedDate(datoUsuario.fechaAct)" disabled>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div v-if="datoUsuario.suscriptor === 1">
      <p>Eres un usuario suscriptor, cómo deseas registrarte:</p>
      <!-- Botones para la navegación -->
      <button @click="navegarComoMedico" class="botonRegistro">Soy Médico - Registrarme</button>
<!--
      <button @click="navegarComoAdministrador" class="botonRegistro">Registro para Personal Administrativo</button>
-->

    </div>   
    <Footer />
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import AyudaUsuario from '@/views/ayuda/AyudaUsuario.vue'
import dateFormat from '@/modules/dateFormat.js';
import { validarForm } from '@/modules/validacionesForms.js'
import { createBooleanField } from '@/modules/casillaVerificacion.js'

import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from 'sweetalert'
export default {
  components: {
    Layout, Footer, AyudaUsuario
  },
  data() {
    return {
      usuarios: [],
      datoUsuario: {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      modalWindow: true,
      mostrarBloque: false,
      p_idUsuario: 0,
      p_idPersona: 0,
      perfils: [],
      suscripcions: [],
      modulo: 0,
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  computed: {
    moduloAdministracionBoolean: createBooleanField('moduloAdministracion'),
    moduloAtencionBoolean: createBooleanField('moduloAtencion'),
    moduloFacturacionBoolean: createBooleanField('moduloFacturacion'),
    moduloDashboardsBoolean: createBooleanField('moduloDashboards'),
    menuParametrosBoolean: createBooleanField('menuParametros'),
    menuProcesosBoolean: createBooleanField('menuProcesos'),
    menuReportesBoolean: createBooleanField('menuReportes'),
    menuAyudaBoolean: createBooleanField('menuAyuda'),
    opcionConsultaBoolean: createBooleanField('opcionConsulta'),
    opcionOperacionesBoolean: createBooleanField('opcionOperaciones'),
    opcionDescargaBoolean: createBooleanField('opcionDescarga'),
    opcionMenuBoolean: createBooleanField('opcionMenu'),
    suscriptorBoolean: createBooleanField('suscriptor')
  },
  mounted() {
    this.p_idUsuario = this.$route.params.p_idusuario
    this.modulo = window.sessionStorage.getItem("modulo")
    this.p_idPersona = window.sessionStorage.getItem("idPersona");
    this.getData()
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    //    this.fetchPerfils()
    //    this.fetchSuscripcions()
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    mostrarOcultarBloque() {
      this.mostrarBloque = !this.mostrarBloque;
    },
    getData() {
      api.get('/vwusuarios/' + this.p_idUsuario)
        .then(response => {
          this.datoUsuario = response.data;
        })
        .catch(error => {
          console.error('Error al obtener datos de la persona:', error);
        });
    },
    validarForm() {
      const requiredFields = [
        'idPerfil'
        , 'idSuscripcion'
        , 'nombre'
        , 'clave'
        /*         ,'moduloAdministracion'
                ,'moduloAtencion'
                ,'moduloFacturacion'
                ,'moduloDashboards'
                ,'menuParametros'
                ,'menuProcesos'
                ,'menuReportes'
                ,'menuAyuda'
                ,'opcionConsulta'
                ,'opcionOperaciones'
                ,'opcionDescarga'
                ,'opcionMenu' */
      ];
      const requiredFieldsText = [
        'idPerfil'
        , 'idSuscripcion'
        , 'nombre'
        , 'clave'
        /*         ,'moduloAdministracion'
                ,'moduloAtencion'
                ,'moduloFacturacion'
                ,'moduloDashboards'
                ,'menuParametros'
                ,'menuProcesos'
                ,'menuReportes'
                ,'menuAyuda'
                ,'opcionConsulta'
                ,'opcionOperaciones'
                ,'opcionDescarga'
                ,'opcionMenu' */
      ];
      return validarForm(this.datoUsuario, requiredFields, requiredFieldsText);
    },
    /*     async guardarUsuario(){
          if(this.validarForm() === 1){
            try {
              this.datoUsuario.idUsuario = window.sessionStorage.getItem("idUsuario");
              this.datoUsuario.idEmpresa = window.sessionStorage.getItem("idEmpresa");
              this.datoUsuario.idUsuarioReg = window.sessionStorage.getItem("idUsuarioReg");
              await api.post('/usuarios', this.datoUsuario)
              $('#ventanaModal').modal('hide');
              swal("Correcto!", "Usuario creada exitosamente!", "success");
              this.getDataPagina(this.paginaActual);
            } catch (error) { 
              swal("Error!", "Intentelo de nuevo!", "error");
            }
          }
        }, */
    async guardarEditUsuario() {
      if (this.validarForm() === 1) {
        try {
          this.datoUsuario.idUsuarioAct = window.sessionStorage.getItem("idUsuario");
          await api.post('/usuarios', this.datoUsuario)
          swal("Correcto!", "Usuario creada exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    /*     fetchPerfils() {
          fetch('http://localhost:8080/api/v1/perfils')
            .then(response => response.json())
            .then(data => {
              this.perfils = data;
            })
            .catch(error => {
              console.error('Error fetching perfils:', error);
            });
        },
        fetchSuscripcions() {
          fetch('http://localhost:8080/api/v1/suscripcions')
            .then(response => response.json())
            .then(data => {
              this.suscripcions = data;
            })
            .catch(error => {
              console.error('Error fetching suscripcions:', error);
            });
        }, */
    openHelp() {
      this.popupAyuda = true;
      this.$refs.helpPopup.open();
    },
    handlePopupClosed() {
      this.popupAyuda = false;
    },
    navegarComoMedico() {
      this.$router.push('/medico02/' + this.datoUsuario.idPersona);
    },
/*
    navegarComoAdministrador() {
      this.$router.push('/usuarioadm02/' + this.datoUsuario.idPersona);
    }
*/
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
<style scoped>
.botonRegistro {
  margin: 5px;
  padding: 10px 20px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.botonRegistro:hover {
  background-color: #45a049;
}
</style>